import domReady from '@roots/sage/client/dom-ready';
import {animations} from './animations.js';
import {mainnav} from './mainnav.js';
import {assistantsDay} from './assistants-day.js';

/**
 * Application entrypoint
 */
domReady(async (err) => {
  if (err) {
    // handle hmr errors
    console.error(err);
  }

  /*
   * Show sticky navigation on scroll up
   */
  mainnav();
  /*
  /* div Elements Animations on scroll
  */
  animations();
  /*
   * Assistants Day list
   */
  assistantsDay();
  /*
   * Show current screen resolution in dev mode
   */
  if (
    window.location.origin.endsWith('.local') ||
    window.location.origin.endsWith('.local:3000')
  ) {
    const infoBoxSR = document.createElement('div');
    infoBoxSR.className = 'screen-resolution';
    document.getElementsByTagName('body')[0].appendChild(infoBoxSR);
    infoBoxSR.innerHTML = window.innerWidth + 'x' + window.innerHeight;
    //window.addEventListener('resize', showScreenRes);

    const infoBoxSR_Resize = document.querySelector('.screen-resolution');

    // Change values when window is resized
    window.onresize = function () {
      infoBoxSR_Resize.innerHTML = window.innerWidth + 'x' + window.innerHeight;
    };
  }
});

/**
 * @see {@link https://webpack.js.org/api/hot-module-replacement/}
 */
if (import.meta.webpackHot) import.meta.webpackHot.accept(console.error);
